document.addEventListener('turbolinks:load', () => {
  const uploadStatus = document.getElementById('upload-status');
  const fileInput = document.getElementById('return-mail-mailing-photo');
  const form = document.getElementById('return-mail-form');
  const searchInput = document.getElementById('unit-search-input');
  const hiddenUnitInput = document.getElementById('return_mail_unit_id');
  const selectionDisplay = document.getElementById('unit-selection-display');
  const options = document.querySelectorAll('#unit-search-options option');
  const prefixContainer = document.querySelector('.unit-search-block[data-order-prefix]');
  const defaultPrefix = prefixContainer ? prefixContainer.dataset.orderPrefix : '';

  if (!form) return;

  const optionMap = {};
  options.forEach((option) => {
    optionMap[option.value] = option;
  });

  const revealSelection = (option) => {
    if (!selectionDisplay || !option) return;
    selectionDisplay.innerHTML = `
      <strong>Current Selection</strong>
      <span>Unit Name: ${option.dataset.unitName || 'Unknown'}</span>
      <span>Unit ID: ${option.value}</span>
      <span>Address: ${option.dataset.unitAddress || 'Not provided'}</span>
    `;
    selectionDisplay.classList.add('is-visible');
  };

  const normalizeValue = (value) => {
    if (!value) return value;
    if (optionMap[value]) return value;
    if (defaultPrefix && !value.includes('-')) {
      const prefixed = `${defaultPrefix}${value}`;
      return prefixed;
    }
    return value;
  };

  const updateHiddenField = (value) => {
    if (!hiddenUnitInput) return;
    const lookupValue = normalizeValue(value.trim());
    const matchedOption = optionMap[lookupValue];
    if (matchedOption) {
      hiddenUnitInput.value = matchedOption.dataset.unitId;
      revealSelection(matchedOption);
      if (searchInput && searchInput.value !== lookupValue) {
        searchInput.value = lookupValue;
      }
    }
  };

  if (searchInput) {
    searchInput.addEventListener('input', (event) => {
      updateHiddenField(event.target.value);
    });

    updateHiddenField(searchInput.value);
  }

  if (fileInput && uploadStatus) {
    fileInput.addEventListener('change', () => {
      if (fileInput.files.length > 0) {
        uploadStatus.textContent = `Ready to upload ${fileInput.files[0].name}`;
        uploadStatus.classList.add('is-visible');
      } else {
        uploadStatus.textContent = '';
        uploadStatus.classList.remove('is-visible');
      }
    });
  }

  if (form && uploadStatus) {
    form.addEventListener('submit', () => {
      if (fileInput && fileInput.files.length > 0) {
        uploadStatus.textContent = 'Uploading...';
        uploadStatus.classList.add('is-visible');
      }
    });
  }
});
